import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export function checkStatus(code) {
	const errorCode = code;

	switch (errorCode) {
		// force log-out if expired token
		case 462:
			localStorage.clear();
			Cookies.remove('_uniqueDeviceId');
			// window.replace('/');
			window.location.reload();
			toast.error('توکن شما منقضی شده است !', {
				position: toast.POSITION.TOP_CENTER,
			});
			break;

		default:
			break;
	}
}
